<template>
  <div class="in-dm-avatar" :style="{ width: `${size}px`, height: `${size}px` }">
    <img v-if="pictureUrl && !hasError" class="in-dm-avatar__img" :src="pictureUrl" :alt="fileName" @error="onError" />
    <img
      v-else
      class="in-dm-avatar__img"
      src="@/client/assets/images/instagram_default_profile.png"
      alt="instagram_default_profile.png"
    />
  </div>
</template>

<script lang="ts">
const DEFAULT_SIZE = 40 // Vue 2.7 の defineProps 巻き上げエラーを回避するため、モジュールスコープで定義
</script>

<script setup lang="ts">
import { computed } from 'vue'

import { useErrorState } from '@/client/components/_hooks/useErrorState'
import { extractFileName } from '@/client/utils/string'

interface Props {
  pictureUrl: string | null
  size?: number
}

const props = withDefaults(defineProps<Props>(), {
  size: DEFAULT_SIZE
})
const { hasError, onError } = useErrorState()
const fileName = computed(() => extractFileName(props.pictureUrl ?? ''))
</script>

<style lang="scss" scoped>
.in-dm-avatar {
  overflow: hidden;
  border-radius: 50%;
}

.in-dm-avatar__img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
